/* WINMEGAFIX729 */
/* NAVALLDEVICES HOMEPAGE_JS_FIX_729B */
/* Oxiram Recovery Ritual homepage interactions — index (9) */
(function () {
  function initHero(root) {
    var hero = root.classList.contains('hero') ? root : root.querySelector('.hero');
    if (!hero) return;
    var slides = hero.querySelectorAll('.hero-slide');
    var dotsWrap = hero.querySelector('[data-hero-dots]');
    var prev = hero.querySelector('[data-hero-prev]');
    var next = hero.querySelector('[data-hero-next]');
    if (!slides.length || !dotsWrap) return;

    var labels = Array.prototype.map.call(slides, function (s, i) {
      return s.getAttribute('data-label') || String(i + 1).padStart(2, '0');
    });
    var current = 0;
    var timer;
    var interval = parseInt(hero.getAttribute('data-interval') || '7000', 10);

    function playSlideVideo(slide) {
      var videos = hero.querySelectorAll('video');
      Array.prototype.forEach.call(videos, function (v) {
        try {
          v.pause();
        } catch (e) {}
      });
      var activeVideo = slide.querySelector('video');
      if (!activeVideo) return;
      activeVideo.muted = true;
      activeVideo.setAttribute('muted', '');
      activeVideo.playsInline = true;
      var tryPlay = function () {
        var p = activeVideo.play();
        if (p && p.catch) p.catch(function () {});
      };
      try {
        activeVideo.currentTime = 0;
      } catch (e) {}
      if (activeVideo.readyState >= 2) {
        tryPlay();
      } else {
        activeVideo.addEventListener('loadeddata', tryPlay, { once: true });
        try {
          activeVideo.load();
        } catch (e2) {}
        tryPlay();
      }
    }

    dotsWrap.innerHTML = '';
    slides.forEach(function (s, i) {
      var dot = document.createElement('div');
      dot.className = 'hero-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('role', 'button');
      dot.setAttribute('tabindex', '0');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.innerHTML = '<span>' + labels[i] + '</span><div class="track"><div class="fill"></div></div>';
      function go() {
        goTo(i);
      }
      dot.addEventListener('click', go);
      dot.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          go();
        }
      });
      dotsWrap.appendChild(dot);
    });
    var dots = dotsWrap.querySelectorAll('.hero-dot');

    function goTo(i) {
      slides[current].classList.remove('active');
      dots[current].classList.remove('active');
      current = (i + slides.length) % slides.length;
      slides[current].classList.add('active');
      dots[current].classList.add('active');
      playSlideVideo(slides[current]);
      resetTimer();
    }

    function resetTimer() {
      clearTimeout(timer);
      if (slides.length > 1) {
        timer = setTimeout(function () {
          goTo(current + 1);
        }, interval);
      }
    }

    if (next)
      next.addEventListener('click', function () {
        goTo(current + 1);
      });
    if (prev)
      prev.addEventListener('click', function () {
        goTo(current - 1);
      });

    playSlideVideo(slides[0]);
    resetTimer();

    document.addEventListener(
      'visibilitychange',
      function () {
        if (!document.hidden) playSlideVideo(slides[current]);
      },
      { passive: true }
    );
  }

  function initSpotlight(root) {
    var wrap = root.classList.contains('oxiram-spotlight')
      ? root
      : root.querySelector('[data-oxiram-spotlight]');
    if (!wrap) return;
    var tabs = wrap.querySelectorAll('[data-spotlight-index]');
    var video = wrap.querySelector('[data-spotlight-video]');
    var eyebrow = wrap.querySelector('[data-spotlight-eyebrow]');
    var title = wrap.querySelector('[data-spotlight-title]');
    if (!tabs.length || !video) return;

    function activate(tab) {
      tabs.forEach(function (t) {
        t.classList.toggle('active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      var url = tab.getAttribute('data-video-url') || '';
      var poster = tab.getAttribute('data-poster') || '';
      if (poster) video.setAttribute('poster', poster);
      if (eyebrow) eyebrow.textContent = tab.getAttribute('data-eyebrow') || '';
      if (title) title.textContent = tab.getAttribute('data-title') || '';
      if (url) {
        var source = video.querySelector('source') || document.createElement('source');
        source.setAttribute('type', 'video/mp4');
        source.setAttribute('src', url);
        if (!source.parentNode) video.appendChild(source);
        video.load();
        video.play().catch(function () {});
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab);
      });
    });
  }

  function initMarquee(root) {
    var section = root.matches && root.matches('[data-oxiram-marquee]')
      ? root
      : root.querySelector('[data-oxiram-marquee]');
    if (!section || section.getAttribute('data-marquee-ready')) return;
    section.setAttribute('data-marquee-ready', '1');

    var track = section.querySelector('[data-marquee-track]');
    var toggle = section.querySelector('[data-marquee-toggle]');
    var label = section.querySelector('[data-marquee-label]');
    if (!track) return;

    var scrollPlaying = true;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      track.classList.add('is-paused');
      scrollPlaying = false;
      if (label) label.textContent = 'Resume Scroll';
    }

    function playVideos() {
      section.querySelectorAll('.m-media video').forEach(function (vid) {
        vid.muted = true;
        vid.loop = true;
        var playPromise = vid.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      });
    }

    function pauseCardVideo(card) {
      var vid = card.querySelector('video');
      if (vid) vid.pause();
    }

    function resumeCardVideo(card) {
      var vid = card.querySelector('video');
      if (!vid) return;
      vid.muted = true;
      var playPromise = vid.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }

    playVideos();

    section.querySelectorAll('.m-card').forEach(function (card) {
      function activate() {
        card.classList.add('is-active');
        track.classList.add('is-paused');
        pauseCardVideo(card);
      }
      function deactivate() {
        card.classList.remove('is-active');
        if (scrollPlaying) track.classList.remove('is-paused');
        resumeCardVideo(card);
      }

      card.addEventListener('mouseenter', activate);
      card.addEventListener('mouseleave', deactivate);
      card.addEventListener('touchstart', function () {
        activate();
      }, { passive: true });
      card.addEventListener('touchend', function () {
        window.setTimeout(deactivate, 160);
      }, { passive: true });
    });

    section.querySelectorAll('[data-marquee-mute]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var media = btn.closest('.m-media');
        var vid = media ? media.querySelector('video') : null;
        if (!vid) return;
        // Mute/unmute only; keep paused state if user is hovering
        section.querySelectorAll('.m-media video').forEach(function (other) {
          if (other !== vid) other.muted = true;
        });
        vid.muted = !vid.muted;
        btn.style.color = vid.muted ? 'var(--ivory)' : 'var(--gold-light)';
        btn.setAttribute('aria-label', vid.muted ? 'Unmute clip' : 'Mute clip');
        if (vid.paused && !btn.closest('.m-card').classList.contains('is-active')) {
          vid.play().catch(function () {});
        }
      });
    });

    section.querySelectorAll('.m-card[data-href]').forEach(function (card) {
      function go() {
        var href = card.getAttribute('data-href');
        if (href) window.location.href = href;
      }
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-marquee-mute]')) return;
        go();
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          go();
        }
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        scrollPlaying = !scrollPlaying;
        track.classList.toggle('is-paused', !scrollPlaying);
        if (label) label.textContent = scrollPlaying ? 'Pause Scroll' : 'Resume Scroll';
      });
    }
  }

  function syncHeaderOffset() {
    var announce = document.querySelector('.section-oxiram-announce .announce, [data-oxiram-announce]');
    var header = document.querySelector('[data-oxiram-header]');
    var announceH = announce ? Math.ceil(announce.getBoundingClientRect().height) : 0;
    var headerH = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--oxiram-announce-h', announceH + 'px');
    document.documentElement.style.setProperty('--oxiram-header-offset', (announceH + headerH) + 'px');
  }

  function initHeader(root) {
    var header = document.querySelector('[data-oxiram-header]');
    var btn = document.querySelector('[data-oxiram-hamburger]');
    var drawer = document.querySelector('[data-oxiram-drawer]');
    var close = document.querySelector('[data-oxiram-drawer-close]');
    var backdrop = document.querySelector('[data-oxiram-mega-backdrop]');
    if (!header) return;
    syncHeaderOffset();
    window.addEventListener('resize', syncHeaderOffset);
    if (header.getAttribute('data-nav-bound')) return;
    header.setAttribute('data-nav-bound', '1');

    /* Reparent drawer/backdrop to <body> so sticky/overflow ancestors
       cannot clip them on Android, Windows, and iPad browsers. */
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    if (backdrop && backdrop.parentElement !== document.body) {
      document.body.appendChild(backdrop);
    }

    var megaRoot = header;
    var shopMega = header.querySelector('[data-oxiram-shop-mega]');
    var triggers = header.querySelectorAll('[data-oxiram-mega-trigger]');
    var panels = shopMega ? shopMega.querySelectorAll('[data-oxiram-mega-panel]') : [];
    var hubTabs = shopMega ? shopMega.querySelectorAll('[data-oxiram-hub-tab]') : [];
    var hubPanels = shopMega ? shopMega.querySelectorAll('[data-oxiram-hub-panel]') : [];
    var hubTiles = shopMega ? shopMega.querySelectorAll('[data-oxiram-hub-tile]') : [];
    var closeTimer = null;
    var isOpen = false;
    var activeCat = null;
    var hubCat = null;

    function isMobileNav() {
      return window.matchMedia('(max-width: 1280px)').matches;
    }

    /* True mouse/trackpad desktops: hover opens mega. Touch / coarse
       pointers (Android laptops, many Windows tablets): click toggles. */
    function prefersHoverNav() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    function clearCloseTimer() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function setBackdrop(on) {
      header.classList.toggle('is-mega-open', !!on);
      if (!backdrop) return;
      if (on) {
        backdrop.classList.add('is-visible');
        backdrop.removeAttribute('hidden');
        backdrop.setAttribute('aria-hidden', 'false');
      } else {
        backdrop.classList.remove('is-visible');
        backdrop.setAttribute('hidden', '');
        backdrop.setAttribute('aria-hidden', 'true');
      }
    }

    function setHubPreview(catId) {
      if (!catId || !shopMega) return;
      hubCat = catId;
      Array.prototype.forEach.call(hubTabs, function (tab) {
        var on = tab.getAttribute('data-oxiram-hub-tab') === catId;
        tab.classList.toggle('is-active', on);
        if (tab.hasAttribute('aria-pressed')) {
          tab.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        if (tab.hasAttribute('aria-current')) {
          tab.setAttribute('aria-current', on ? 'true' : 'false');
        }
      });
      Array.prototype.forEach.call(hubPanels, function (panel) {
        var on = panel.getAttribute('data-oxiram-hub-panel') === catId;
        panel.classList.toggle('is-hidden', !on);
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
      Array.prototype.forEach.call(hubTiles, function (tile) {
        tile.classList.toggle('is-active', tile.getAttribute('data-oxiram-hub-tile') === catId);
      });
    }

    function setActiveCategory(catId) {
      if (!shopMega) return;
      var panelId = catId || 'shop-all';
      activeCat = catId || null;

      Array.prototype.forEach.call(panels, function (panel) {
        var on = panel.getAttribute('data-oxiram-mega-panel') === panelId;
        panel.classList.toggle('is-hidden', !on);
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });

      Array.prototype.forEach.call(triggers, function (trigger) {
        var item = trigger.closest('[data-oxiram-mega-item]');
        var tCat = trigger.getAttribute('data-oxiram-mega-cat') || '';
        var match = catId ? tCat === catId : trigger.classList.contains('nav-link--shop-all');
        trigger.setAttribute('aria-expanded', isOpen && match ? 'true' : 'false');
        if (item) item.classList.toggle('is-open', isOpen && match);
        if (trigger.classList.contains('nav-link--shop-all')) {
          trigger.classList.toggle('is-open', isOpen && !catId);
        }
      });

      if (!catId) {
        var firstHub = hubTabs[0] && hubTabs[0].getAttribute('data-oxiram-hub-tab');
        setHubPreview(hubCat || firstHub);
      }
    }

    function hydrateMegaImages() {
      if (!shopMega) return;
      Array.prototype.forEach.call(shopMega.querySelectorAll('img'), function (img) {
        try {
          img.loading = 'eager';
          img.setAttribute('loading', 'eager');
          /* Retrigger decode for images that stayed unloaded while [hidden]/display:none). */
          var src = img.currentSrc || img.getAttribute('src');
          if (src) {
            img.setAttribute('src', src);
          }
          if (img.decode) img.decode().catch(function () {});
        } catch (err) {}
      });
    }

    function openMega(catId) {
      if (!shopMega || isMobileNav()) return;
      clearCloseTimer();
      var resolved = typeof catId === 'string' ? catId : '';
      setActiveCategory(resolved);
      shopMega.classList.add('is-open');
      shopMega.removeAttribute('hidden');
      isOpen = true;
      setBackdrop(true);
      setActiveCategory(resolved);
      hydrateMegaImages();
    }

    function closeMega() {
      clearCloseTimer();
      if (!shopMega) return;
      shopMega.classList.remove('is-open');
      shopMega.setAttribute('hidden', '');
      isOpen = false;
      Array.prototype.forEach.call(triggers, function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.classList.remove('is-open');
        var item = trigger.closest('[data-oxiram-mega-item]');
        if (item) item.classList.remove('is-open');
      });
      setBackdrop(false);
    }

    function scheduleClose() {
      clearCloseTimer();
      closeTimer = setTimeout(closeMega, 200);
    }

    Array.prototype.forEach.call(triggers, function (trigger) {
      var catId = trigger.getAttribute('data-oxiram-mega-cat') || '';
      var item = trigger.closest('[data-oxiram-mega-item]');

      function enter() {
        if (isMobileNav()) return;
        openMega(catId);
      }

      if (item) {
        item.addEventListener('mouseenter', enter);
        item.addEventListener('mouseleave', function () {
          if (isMobileNav() || !prefersHoverNav()) return;
          scheduleClose();
        });
      } else {
        trigger.addEventListener('mouseenter', enter);
        trigger.addEventListener('mouseleave', function () {
          if (isMobileNav() || !prefersHoverNav()) return;
          scheduleClose();
        });
      }

      trigger.addEventListener('focus', enter);
      trigger.addEventListener('click', function (e) {
        if (isMobileNav()) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;

        /* Touch / coarse pointers: first tap opens mega; second tap navigates. */
        if (!prefersHoverNav()) {
          var same =
            isOpen &&
            ((catId && activeCat === catId) || (!catId && !activeCat && trigger.classList.contains('nav-link--shop-all')));
          if (same) {
            closeMega();
            return;
          }
          e.preventDefault();
          openMega(catId);
          return;
        }

        /* Fine pointer: hover already opened mega; click navigates. */
        closeMega();
      });
    });

    if (shopMega) {
      shopMega.addEventListener('mouseenter', clearCloseTimer);
      shopMega.addEventListener('mouseleave', function () {
        if (isMobileNav() || !prefersHoverNav()) return;
        scheduleClose();
      });
    }

    Array.prototype.forEach.call(hubTabs, function (tab) {
      tab.addEventListener('mouseenter', function () {
        setHubPreview(tab.getAttribute('data-oxiram-hub-tab'));
      });
      tab.addEventListener('focus', function () {
        setHubPreview(tab.getAttribute('data-oxiram-hub-tab'));
      });
      /* Click navigates via href — do not preventDefault */
    });

    Array.prototype.forEach.call(hubTiles, function (tile) {
      tile.addEventListener('mouseenter', function () {
        setHubPreview(tile.getAttribute('data-oxiram-hub-tile'));
      });
    });

    if (backdrop) {
      backdrop.addEventListener('click', closeMega);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) closeMega();
    });
    document.addEventListener('click', function (e) {
      if (!isOpen) return;
      if (megaRoot && megaRoot.contains(e.target)) return;
      if (backdrop && (e.target === backdrop || backdrop.contains(e.target))) return;
      closeMega();
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (isMobileNav() && isOpen) closeMega();
      }, 120);
    });

    function openDrawer() {
      if (!drawer || !btn) return;
      if (drawer.parentElement !== document.body) {
        document.body.appendChild(drawer);
      }
      drawer.classList.add('open');
      drawer.removeAttribute('hidden');
      drawer.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer || !btn) return;
      drawer.classList.remove('open');
      drawer.setAttribute('hidden', '');
      drawer.setAttribute('aria-hidden', 'true');
      btn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    if (btn && drawer) {
      var lastToggleAt = 0;
      function toggleDrawer(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        var now = Date.now();
        if (now - lastToggleAt < 450) return;
        lastToggleAt = now;
        if (drawer.classList.contains('open')) closeDrawer();
        else openDrawer();
      }
      btn.addEventListener('click', toggleDrawer);
      if (close) close.addEventListener('click', closeDrawer);
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) closeDrawer();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
      });
    }
  }

  function initBundle(root) {
    var section = root.matches && root.matches('[data-oxiram-bundle]')
      ? root
      : root.querySelector('[data-oxiram-bundle]');
    if (!section || section.getAttribute('data-bundle-ready')) return;
    section.setAttribute('data-bundle-ready', '1');

    var addBtn = section.querySelector('[data-bundle-add]');
    if (!addBtn) return;
    addBtn.addEventListener('click', function () {
      var v1 = addBtn.getAttribute('data-variant-1');
      var v2 = addBtn.getAttribute('data-variant-2');
      var label = addBtn.querySelector('[data-bundle-label]');
      if (!v1 || !v2) return;
      addBtn.classList.add('is-loading');
      if (label) label.textContent = 'Adding duo…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: Number(v1), quantity: 1 },
            { id: Number(v2), quantity: 1 }
          ]
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        })
        .then(function () {
          if (label) label.textContent = 'Added — opening cart…';
          window.location.href = '/cart';
        })
        .catch(function () {
          addBtn.classList.remove('is-loading');
          if (label) label.textContent = 'Try again';
          setTimeout(function () {
            if (label) label.textContent = addBtn.getAttribute('data-default-label') || 'Add Duo to Cart — Save 20%';
          }, 1800);
        });
    });
    if (addBtn.querySelector('[data-bundle-label]')) {
      addBtn.setAttribute(
        'data-default-label',
        addBtn.querySelector('[data-bundle-label]').textContent
      );
    }
  }

  function initReveal(root) {
    var items = root.querySelectorAll(
      '.section-head, .prod-card, .pillar-card, .testi-card, .cat-tile, .bundle-card, .trust-item, .rec-item, .spotlight-grid, .m-card'
    );
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) {
        el.style.opacity = 1;
        el.style.transform = 'none';
      });
      return;
    }
    Array.prototype.forEach.call(items, function (el) {
      el.style.opacity = 0;
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity .7s ease, transform .7s ease';
    });
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.style.opacity = 1;
            e.target.style.transform = 'translateY(0)';
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    Array.prototype.forEach.call(items, function (el) {
      obs.observe(el);
    });
  }

  function initCatCarousel(root) {
    var sections = root.querySelectorAll('[data-cat-carousel]');
    if (!sections.length && root.matches && root.matches('[data-cat-carousel]')) {
      sections = [root];
    }
    Array.prototype.forEach.call(sections, function (section) {
      if (section.getAttribute('data-cat-ready')) return;
      var track = section.querySelector('[data-cat-track]');
      var prev = section.querySelector('[data-cat-prev]');
      var next = section.querySelector('[data-cat-next]');
      var progress = section.querySelector('[data-cat-progress]');
      var indexEl = section.querySelector('[data-cat-index]');
      var carousel = section.querySelector('.cat-carousel');
      var tiles = track ? track.querySelectorAll('.cat-tile') : [];
      if (!track) return;
      section.setAttribute('data-cat-ready', '1');

      function pad2(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function update() {
        var max = maxScroll();
        var left = track.scrollLeft;
        var atStart = left <= 2;
        var atEnd = left >= max - 2;
        if (prev) prev.disabled = atStart || max <= 0;
        if (next) next.disabled = atEnd || max <= 0;
        if (carousel) {
          carousel.classList.toggle('is-end', atEnd || max <= 0);
          carousel.classList.toggle('is-start', atStart);
        }
        if (progress) {
          var ratio = max > 0 ? left / max : 1;
          progress.style.width = Math.max(10, Math.min(100, ratio * 100)) + '%';
        }
        if (indexEl && tiles.length) {
          var tile = tiles[0];
          var step = tile ? tile.getBoundingClientRect().width + 1 : 1;
          var idx = Math.min(tiles.length, Math.max(1, Math.round(left / step) + 1));
          indexEl.textContent = pad2(idx);
        }
      }

      function scrollByDir(dir) {
        var tile = tiles[0];
        var amount = tile
          ? Math.round(tile.getBoundingClientRect().width + 1)
          : Math.round(track.clientWidth * 0.85);
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
      if (next) next.addEventListener('click', function () { scrollByDir(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          scrollByDir(1);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          scrollByDir(-1);
        }
      });

      update();
    });
  }

  function boot(root) {
    if (!root) return;
    initHero(root);
    initSpotlight(root);
    initMarquee(root);
    initBundle(root);
    initCatCarousel(root);
    initReveal(root);
  }

  function bootAll() {
    document.querySelectorAll('.oxiram-lux').forEach(boot);
    initHeader(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.oxiram-lux') || e.target;
    if (root && root.classList && root.classList.contains('oxiram-lux')) {
      if (root.querySelector('[data-oxiram-marquee]')) {
        var m = root.querySelector('[data-oxiram-marquee]');
        if (m) m.removeAttribute('data-marquee-ready');
      }
      boot(root);
    }
    initHeader(document);
  });
})();

/* OXIRAM_BUNDLE_BOOT_729 */
/* BUNDLERESP729 */
(function () {
  'use strict';

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function moneyFromCents(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, format || undefined);
      } catch (e) {}
    }
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function refreshCartUI() {
    return fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.oxiram-header .badge, .icon-btn .badge, .cart-count-bubble span').forEach(function (b) {
          if (!b) return;
          b.textContent = String(cart.item_count);
          if ('hidden' in b) b.hidden = cart.item_count < 1;
        });
        document.querySelectorAll('.oxiram-header .icon-btn[aria-label="Cart"], a[href$="/cart"]').forEach(function (a) {
          if (!a || !a.classList.contains('icon-btn')) return;
          var badge = a.querySelector('.badge');
          if (cart.item_count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'badge';
              a.appendChild(badge);
            }
            badge.textContent = String(cart.item_count);
            badge.hidden = false;
          } else if (badge) {
            badge.hidden = true;
          }
        });
        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        } catch (e) {}
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { cart: cart }); } catch (e2) {}
        }
        return cart;
      })
      .catch(function () { return null; });
  }

  function parseVariantIds(raw) {
    return String(raw || '')
      .split(',')
      .map(function (s) { return Number(String(s).trim()); })
      .filter(function (n) { return n > 0; });
  }

  function addBundleItems(ids, qty) {
    var items = ids.map(function (id) {
      return { id: id, quantity: qty };
    });
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var msg = (data && (data.description || data.message)) || 'Could not add bundle';
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  function setButtonLabel(btn, text) {
    if (!btn) return;
    var label = btn.querySelector('[data-btn-label]');
    if (label) label.textContent = text;
    else btn.textContent = text;
  }

  function initCard(card) {
    var stepper = card.querySelector('[data-qty-stepper]');
    var valueEl = stepper && stepper.querySelector('[data-qty-value]');
    var minus = stepper && stepper.querySelector('[data-qty-minus]');
    var plus = stepper && stepper.querySelector('[data-qty-plus]');
    var addBtn = card.querySelector('[data-bundle-add]');
    var buyBtn = card.querySelector('[data-bundle-buy]');
    var status = card.querySelector('[data-bundle-status]');
    if (!addBtn && !buyBtn) return;
    if (card.getAttribute('data-bundle-card-bound')) return;
    card.setAttribute('data-bundle-card-bound', '1');

    var qty = 1;
    function setQty(n) {
      qty = Math.max(1, Math.min(10, n | 0));
      if (valueEl) valueEl.textContent = String(qty);
    }
    if (minus) {
      minus.addEventListener('click', function (e) {
        e.preventDefault();
        setQty(qty - 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function (e) {
        e.preventDefault();
        setQty(qty + 1);
      });
    }

    function runAdd(btn, goCheckout) {
      if (!btn || btn.disabled) return;
      var ids = parseVariantIds(btn.getAttribute('data-variants'));
      if (!ids.length) {
        if (status) status.textContent = 'Bundle products are not configured yet.';
        return;
      }

      var unitCents = Number(addBtn && addBtn.getAttribute('data-price-cents') || btn.getAttribute('data-price-cents') || 0);
      var format = (addBtn && addBtn.getAttribute('data-money-format')) || '';
      var totalLabel = moneyFromCents(unitCents * qty, format || undefined);

      var defaultAdd = addBtn && (addBtn.getAttribute('data-default-label') || 'Add Bundle to Cart');
      var defaultBuy = buyBtn && (buyBtn.getAttribute('data-default-label') || 'Buy now');

      if (addBtn) {
        addBtn.disabled = true;
        addBtn.classList.add('is-loading');
      }
      if (buyBtn) {
        buyBtn.disabled = true;
        buyBtn.classList.add('is-loading');
      }
      setButtonLabel(btn, goCheckout ? 'Redirecting…' : 'Adding…');
      if (status) status.textContent = '';

      addBundleItems(ids, qty)
        .then(function () {
          return refreshCartUI();
        })
        .then(function () {
          if (goCheckout) {
            window.location.href = cartRoot() + 'checkout';
            return;
          }
          setButtonLabel(addBtn, 'Added ✓');
          if (addBtn) addBtn.classList.remove('is-loading');
          if (buyBtn) buyBtn.classList.remove('is-loading');
          if (status) {
            status.textContent = qty + ' × bundle added — ' + totalLabel + '.';
          }
          window.setTimeout(function () {
            setButtonLabel(addBtn, defaultAdd);
            if (addBtn) addBtn.disabled = false;
            if (buyBtn && !buyBtn.hasAttribute('data-keep-disabled')) buyBtn.disabled = false;
          }, 1600);
        })
        .catch(function (err) {
          if (addBtn) addBtn.classList.remove('is-loading');
          if (buyBtn) buyBtn.classList.remove('is-loading');
          setButtonLabel(btn, 'Try again');
          if (status) status.textContent = (err && err.message) || 'Could not add bundle. Please try again.';
          window.setTimeout(function () {
            if (btn === addBtn) setButtonLabel(addBtn, defaultAdd);
            if (btn === buyBtn) setButtonLabel(buyBtn, defaultBuy);
            if (addBtn && !addBtn.hasAttribute('data-keep-disabled')) addBtn.disabled = false;
            if (buyBtn && !buyBtn.hasAttribute('data-keep-disabled')) buyBtn.disabled = false;
          }, 2000);
        });
    }

    if (addBtn) {
      addBtn.setAttribute('data-default-label', (addBtn.textContent || '').trim() || 'Add Bundle to Cart');
      if (addBtn.disabled) addBtn.setAttribute('data-keep-disabled', '1');
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        runAdd(addBtn, false);
      });
    }

    if (buyBtn) {
      var buyLabelEl = buyBtn.querySelector('[data-btn-label]');
      buyBtn.setAttribute(
        'data-default-label',
        (buyLabelEl ? buyLabelEl.textContent : buyBtn.textContent || '').trim() || 'Buy now'
      );
      if (buyBtn.disabled) buyBtn.setAttribute('data-keep-disabled', '1');
      buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        runAdd(buyBtn, true);
      });
    }
  }

  function initReveal(root) {
    var items = root.querySelectorAll('.section-head, .bcard, .faq-item, .trust-item');
    if (!items.length || !('IntersectionObserver' in window)) return;
    Array.prototype.forEach.call(items, function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity .6s ease, transform .6s ease';
    });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    Array.prototype.forEach.call(items, function (el) { obs.observe(el); });
  }

  function boot(root) {
    if (!root || root.getAttribute('data-oxiram-bundles-ready')) return;
    root.setAttribute('data-oxiram-bundles-ready', '1');
    root.querySelectorAll('[data-bundle-card]').forEach(initCard);
    initReveal(root);
  }

  function bootAll() {
    document.querySelectorAll('[data-oxiram-bundles]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-oxiram-bundles]') || e.target;
    if (root && root.hasAttribute && root.hasAttribute('data-oxiram-bundles')) {
      root.removeAttribute('data-oxiram-bundles-ready');
      root.querySelectorAll('[data-bundle-card]').forEach(function (c) {
        c.removeAttribute('data-bundle-card-bound');
      });
      boot(root);
    }
  });
})();

